import { NgModule } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { ConciliacaoComponent } from './components/conciliacao.component';
import { BrowserModule } from '@angular/platform-browser';
import { PrimengModule } from '@modules/primeng.module';
import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { ConciliacaoApiService } from './services/conciliacao-api.service';
import { CardBuscaComponent } from './components/card-busca/card-busca.component';
import { CardLancamentosComponent } from './components/card-lancamentos/card-lancamentos.component';
import { FiltroDialogComponent } from './components/card-busca/filtro-dialog/filtro-dialog.component';
import { BuscaEmMassaDialogComponent } from './components/card-busca/busca-em-massa-dialog/busca-em-massa-dialog.component';
import { ListagemBuscaEmMassaDialogComponent } from './components/card-busca/listagem-busca-em-massa-dialog/listagem-busca-em-massa-dialog.component';
import { CorrespondenciasDiferencaDialogComponent } from './components/card-busca/correspondencias-diferenca-dialog/correspondencias-diferenca-dialog.component';
import { NovaConciliacaoResolver } from './resolvers/nova-conciliacao.resolver';
import { EditarConciliacaoResolver } from './resolvers/editar-conciliacao.resolver';
import { LancamentosTableComponent } from './components/card-lancamentos/lancamentos-table/lancamentos-table.component';
import { ReconciliarLancamentosAntigosResolver } from './resolvers/reconciliar-lancamentos-antigos.resolver';
import { ExibeCorrespondenciaDialogModule } from '../../../shared/dialogs/exibe-correspondencia-dialog/exibe-correspondencia-dialog.module';
import { CadastroLoteLancamentosDialogModule } from '../../../shared/dialogs/cadastro-lote-lancamentos-dialog/cadastro-lote-lancamentos-dialog.module';


@NgModule({
  declarations: [
    ConciliacaoComponent,
    CardBuscaComponent,
    CardLancamentosComponent,
    FiltroDialogComponent,
    BuscaEmMassaDialogComponent,
    ListagemBuscaEmMassaDialogComponent,
    CorrespondenciasDiferencaDialogComponent,
    LancamentosTableComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
    ExibeCorrespondenciaDialogModule,
    CadastroLoteLancamentosDialogModule,
  ],
  providers: [
    { provide: ConciliacaoApiService, useClass: ConciliacaoApiService },
    { provide: CurrencyPipe, useClass: CurrencyPipe },
    NovaConciliacaoResolver,
    EditarConciliacaoResolver,
    ReconciliarLancamentosAntigosResolver
  ],
})
export class ConciliacaoModule { }
